import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
import { MeshoptDecoder } from './meshopt_decoder.module.js';
import { CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer.js';
import { STATE_INFO_BY_FIPS } from './data/FIPS.js';
import TWEEN, { Group as TweenGroup, update as TweenUpdate, Tween } from "./vendor/tweenjs/tween.esm.js";
import { mapTilerApi, mapTilerKey } from './Globe';
import { HighlightableFaceRegion, Region } from './Region.js';

export const nonMainlandList = ['PR', 'VI', 'AS', 'GU', 'MP', 'AK', 'HI']

export class GlobeLoader {

  constructor(globe){
    this.scene = globe
    this.loader = new GLTFLoader();
    this.loader.setMeshoptDecoder(MeshoptDecoder);
    const dracoLoader = new DRACOLoader();
    dracoLoader.setDecoderPath('/vendor/draco/');
    this.loader.setDRACOLoader( dracoLoader );
  }

  // addGlobe(world){

  //   /** **GLTF Loader old way to import shapers***/
  //   const temp = this

  //   const colorMap = new Map();
  //   colorMap.set("Argentina", randGrayScale());
  //   colorMap.set("Bolivia", randGrayScale());
  //   colorMap.set("Brazil", randGrayScale());
  //   colorMap.set("Chile", randGrayScale());
  //   colorMap.set("Colombia", randGrayScale());
  //   colorMap.set("Ecuador", randGrayScale());
  //   colorMap.set("FrenchGuiana", randGrayScale());
  //   colorMap.set("Guyana", randGrayScale());
  //   colorMap.set("Paraguay", randGrayScale());
  //   colorMap.set("Peru", randGrayScale());
  //   colorMap.set("Suriname", randGrayScale());
  //   colorMap.set("Uruguay", randGrayScale());
  //   colorMap.set("Venezuela", randGrayScale());

  //   const defaultColor = randGrayScale();

  //   this.loader.load( '/assets/glb/GlobeEric5.glb', function ( gltf ) {

  //     let object = null; let mesh; let name;
  //     for (let i = 0; i<gltf.scene.children.length; i++){
  //       if (!gltf.scene.children[i].isMesh) {
  //         object = gltf.scene.children[i];
  //         mesh = object.children[0];
  //         name = object.name;
  //       } else {
  //         mesh = gltf.scene.children[i];
  //         object = mesh;
  //         name = object.name;
  //       }

  //       // Check for membership in the color map
  //       if (colorMap.has(name)) {
  //         // Clone the material so we don't affect all the other countries
  //         mesh.material = mesh.material.clone();
  //         // Set color to the color in the map
  //         mesh.material.color.set(colorMap.get(name))
  //       } else {
  //         if (mesh.material.name.includes("face")) {
  //           // TODO: This only needs to be done once technically
  //           mesh.material.color.set(defaultColor);
  //         }
  //       }

  //       if (mesh.isMesh) {
  //         mesh.castShadow = true;
  //         mesh.receiveShadow = true;
  //       }
  //       if (mesh.material){
  //         if (mesh.material.name.includes("Bords")) {
  //           mesh.material.dispose();
  //           mesh.material = new THREE.MeshLambertMaterial({
  //             color: "#5588FF",
  //           });
  //           mesh.material.side = THREE.DoubleSide;
  //           mesh.material.onBeforeCompile = function(shader, renderer) {
  //             temp.injectFakeAO(shader, renderer);
  //           }
  //         } else if (mesh.material.name.includes("conturs")) {
  //           // Replace the physical material on the contours with a simple material for performance
  //           mesh.material.dispose();
  //           mesh.material = new THREE.MeshBasicMaterial( {
  //             color: "#DDD"
  //           });
  //         } else {
  //           mesh.material.onBeforeCompile = function(shader, renderer) {
  //             let uniforms = {
  //               color: { value: new THREE.Vector3(0.85, 0.97, 1.0) },
  //               // +x is right
  //               // +y is up
  //               // +z is away (don't use)
  //               rimOffset: { value: new THREE.Vector3(-15.0, 30.0, 0.0) },
  //               strength: { value: 2.9 },
  //               width: { value:   0.35}
  //             };

  //             temp.injectRimLight(shader, renderer, uniforms);

  //             uniforms = {
  //               color: { value: new THREE.Vector3(0.85, 0.97, 1.0) },
  //               // +x is right
  //               // +y is up
  //               // +z is away (don't use)
  //               rimOffset: { value: new THREE.Vector3(0.0, -60.0, 0.0) },
  //               strength: { value: 1.5 },
  //               width: { value:   0.35}
  //             };

  //             temp.injectRimLight(shader, renderer, uniforms, '2');
  //           }
  //         }
  //       }
  //     }

  //     temp.planet = gltf.scene
  //     temp.planet.name = 'Earth'
  //     temp.planet.scale.x = 50
  //     temp.planet.scale.y = 50
  //     temp.planet.scale.z = 50

  //     temp.planet.rotation.y = -Math.PI/2

  //     world.add(temp.planet)

  //     document.querySelector('canvas').setAttribute('globe',true);
  //     loadingScreen()

  //   }, // called while loading is progressing
	//   function ( xhr ) {

  // 		// console.log( ( xhr.loaded / xhr.total * 100 ) + '% loaded' );
  //     if ((xhr.loaded / xhr.total * 100 ) == 100){

  //     }

  // 	}, function ( error ) {
  //     console.error( error );
  //   } );

  // }

  async addWater(renderer){

    /** **GLTF Loader old way to import shapers***/
    const temp = this

    // const gray = new THREE.MeshBasicMaterial( { color: "#3c3c3c" } );
    const promise = new Promise((resolve, reject) => {
      this.loader.load( '/assets/glb/watermorg14_packed.glb',
        function ( gltf ) {

          let object, mesh, name;
          const b = new THREE.Color(1,1,1);
          const black = b.getHex()
          // console.log(black);
          for (let i = 0; i<gltf.scene.children.length; i++){

            if (!gltf.scene.children[i].isMesh) {
              object = gltf.scene.children[i];
              mesh = object.children[0];
              name = object.name;
            } else {
              mesh = gltf.scene.children[i];
              object = mesh;
              name = object.name;
            }

            // console.log(mesh);
            // mesh.visible = false;
            if (mesh.material){
              if(name === "waves") {
                // Water wavies
                const oldMaterial = mesh.material;
                mesh.material = new THREE.MeshBasicMaterial({
                  // map: oldMaterial.map,
                  color: "#182230",
                });

                mesh.castShadow = true;
                mesh.receiveShadow = false;

                // mesh.material.onBeforeCompile = function(shader, renderer) {
                //   var uniforms = {
                //     color: { value: new THREE.Vector3(0.85, 0.97, 1.0) },
                //     // +x is right
                //     // +y is up
                //     // +z is away (don't use)
                //     rimOffset: { value: new THREE.Vector3(-15.0, 30.0, 0.0) },
                //     strength: { value: 2.9/16},
                //     width: { value:   0.35}
                //   };

                //   temp.injectRimLight(shader, renderer, uniforms);

                //   uniforms = {
                //     color: { value: new THREE.Vector3(0.85, 0.97, 1.0) },
                //     // +x is right
                //     // +y is up
                //     // +z is away (don't use)
                //     rimOffset: { value: new THREE.Vector3(0.0, -60.0, 0.0) },
                //     strength: { value: 1.5/16},
                //     width: { value:   0.35}
                //   };

                //   temp.injectRimLight(shader, renderer, uniforms, '2');
                // }

                // temp.addShader(
                //   mesh,
                //   "/assets/shaders/rimlight.vert",
                //   "/assets/shaders/rimlight.frag",
                //   // uniforms
                //   {
                //     color: { value: new THREE.Vector3(0.85, 0.97, 1.0) },
                //     // +x is right
                //     // +y is up
                //     // +z is away (don't use)
                //     rimOffset: { value: new THREE.Vector3(-15.0, 30.0, 0.0) },
                //     strength: { value: 2.9/16 },
                //     width: { value: 0.35}
                //   }
                // );
                // temp.addShader(
                //   mesh,
                //   "/assets/shaders/rimlight.vert",
                //   "/assets/shaders/rimlight.frag",
                //   // uniforms
                //   {
                //     color: { value: new THREE.Vector3(0.85, 0.97, 1.0) },
                //     // +x is right
                //     // +y is up
                //     // +z is away (don't use)
                //     rimOffset: { value: new THREE.Vector3(0.0, -60.0, 0.0) },
                //     strength: { value: 1.5/16 },
                //     width: { value:   0.35}
                //   }
                // );
                // Add radial gradient to the swirlies
                // temp.addShader(
                //   mesh,
                //   "assets/shaders/rimlight.vert",
                //   "assets/shaders/fakeao.frag",
                //   // uniforms
                //   {
                //     color: { value: new THREE.Vector3(1, 1, 1) },
                //     center: { value: new THREE.Vector3(0, 50, 0) },
                //     // +x is right
                //     // +y is up
                //     // +z is away (don't use)
                //     attenuation: { value: 0.8 },
                //     strength: { value: 0.1 },
                //     startRadius: { value: 50},
                //   },
                //   THREE.MultiplyBlending
                // );
              }
              // temp.addCustomShaders(mesh)
              if((mesh.material.color.getHex() == black || mesh.material.name == "contur_green")&&name != "Sphere"){

                // const gray = randGrayScale()
                // console.log(gray);
                // mesh.material = gray
                // console.log(mesh.material);
              }
              if (name === "Sphere"){
                // console.log('Sphere')g
                // console.log(mesh);
                // mesh.material.polygonOffset = true;
                // mesh.material.color.set("#232628");
                mesh.material.polygonOffsetFactor = 0.2;

                mesh.receiveShadow = true;
                // mesh.castShadow = true;

                // Add rim light shaders

                mesh.material.onBeforeCompile = function(shader, renderer) {
                  let uniforms = {
                    color: { value: new THREE.Vector3(0.85, 0.97, 1.0) },
                    // +x is right
                    // +y is up
                    // +z is away (don't use)
                    rimOffset: { value: new THREE.Vector3(-15.0, 30.0, 0.0) },
                    strength: { value: 2.9 },
                    width: { value:   0.35}
                  };

                  temp.injectRimLight(shader, renderer, uniforms);

                  uniforms = {
                    color: { value: new THREE.Vector3(0.85, 0.97, 1.0) },
                    // +x is right
                    // +y is up
                    // +z is away (don't use)
                    rimOffset: { value: new THREE.Vector3(0.0, -60.0, 0.0) },
                    strength: { value: 1.5 },
                    width: { value:   0.35}
                  };

                  temp.injectRimLight(shader, renderer, uniforms, '2');
                }

                // temp.addShader(
                //   mesh,
                //   "/assets/shaders/rimlight.vert",
                //   "/assets/shaders/rimlight.frag",
                //   // uniforms
                //   {
                //     color: { value: new THREE.Vector3(0.85, 0.97, 1.0) },
                //     // +x is right
                //     // +y is up
                //     // +z is away (don't use)
                //     rimOffset: { value: new THREE.Vector3(-15.0, 30.0, 0.0) },
                //     strength: { value: 2.9 },
                //     width: { value:   0.35}
                //   },
                //   null,
                //   -0.10
                // );
                // temp.addShader(
                //   mesh,
                //   "/assets/shaders/rimlight.vert",
                //   "/assets/shaders/rimlight.frag",
                //   // uniforms
                //   {
                //     color: { value: new THREE.Vector3(0.85, 0.97, 1.0) },
                //     // +x is right
                //     // +y is up
                //     // +z is away (don't use)
                //     rimOffset: { value: new THREE.Vector3(0.0, -60.0, 0.0) },
                //     strength: { value: 1.5 },
                //     width: { value:   0.35}
                //   },
                //   null,
                //   -0.10
                // );
                // console.log('hit');
                // mesh.material.color.setHex('0x40424B');
                // 2C2E37
                // #65666C
                // 696A70
                // #7A8288
                // #595E67
                // #555F73
                // #616773
                // #686f7d
                // #40424B
                // #4D4F57
                // #40424B
                // console.log(mesh);
              }

            }

            // console.log(mesh.material.color);
          }
          // console.log(gltf.scene);
          temp.planet = gltf.scene
          temp.planet.name = 'Earth'
          // console.log(temp.planet);
          temp.planet.scale.x = 50
          temp.planet.scale.y = 50
          temp.planet.scale.z = 50

          // temp.planet.rotation.y = -Math.PI/2 - Math.PI * 0.006
          // temp.planet.rotation.x = Math.PI * 0.003
          // temp.planet.rotation.z = Math.PI * 0.007

          temp.scene.add(temp.planet)

          // document.querySelector('canvas').setAttribute('water',true);
          // loadingScreen()
          resolve(gltf)

        }, // called while loading is progressing
        function ( xhr ) {

          if ((xhr.loaded / xhr.total * 100 ) == 100){

          }

        }, function ( error ) {
          console.error( error );
          reject(error)
        } ) 
    })
    return promise
  }

  // addBumpMap(mesh, path) {
  //   const textureLoader = new THREE.TextureLoader();
  //   textureLoader.load(
  //     path,
  //     function (texture) {
  //       // const newMat = new THREE.MeshPhongMaterial();
  //       var oldMat;
  //       if(Object.prototype.toString.call(mesh.material) == "[object Array]") {
  //         oldMat = mesh.material[0];
  //       } else {
  //         oldMat = mesh.material;
  //       }
  //       oldMat.normalMap = texture;
  //     }
  //   );
  // }
  addShader(mesh, vertPath, fragPath, uniforms, blendMode = null, polygonOffsetFactor = 0) {
    // TODO: Cache the materials so this doesnt generate 100+ fetch requests
    const loader = new THREE.FileLoader();

    // Closure for loading both shaders
    let vertexShader = ""
    let fragmentShader = ""
    let nFilesLoaded = 0;
    function onShaderLoaded() {
      nFilesLoaded++
      // Wait till we've loaded both files
      if (nFilesLoaded != 2)
        return

      // Construct the material
      const material = new THREE.ShaderMaterial( {
        depthWrite: false,
        uniforms,
        vertexShader,
        fragmentShader
      } );

      if (blendMode) {
        material.blending = blendMode;
      } else {
        // Additive blending is good for lighting effects
        material.blending = THREE.CustomBlending;
        material.blendEquation = THREE.AddEquation;
        material.blendSrc = THREE.SrcAlphaFactor;
        material.blendDst = THREE.OneMinusSrcAlphaFactor;
      }

      if (polygonOffsetFactor) {
        material.polygonOffset = true;
        material.polygonOffsetFactor = polygonOffsetFactor;
      }

      if(Object.prototype.toString.call(mesh.material) == "[object Array]") {
        const nextGroupIndex = mesh.material.length;
        mesh.geometry.addGroup(0, Infinity, nextGroupIndex);
        mesh.material.push(material);
      } else {
        // This is a hacky way to blend multiple materials on a mesh
        //  using overlapping vertex groups
        const materials = [mesh.material, material];
        mesh.geometry.addGroup(0, Infinity, 0)
        mesh.geometry.addGroup(0, Infinity, 1)
        mesh.material = materials;
      }
    }

    // Do the loading
    loader.load(fragPath, function(data) {
      fragmentShader = data
      onShaderLoaded();
    } );
    loader.load(vertPath, function(data) {
      vertexShader = data
      onShaderLoaded();
    } );
  }

  isHawaiiOrAlaska(mesh) {
    if (mesh.parent.name.includes("Hawaii"))
      return true;

    if (mesh.parent.name.includes('Alaska'))
      return true;

    return false;
  }

  // Inject the fake AO shader chunk into the passed-in shader
  // Should be called in Material.onBeforeCompile
  injectFakeAO = function () {

    const fakeAOFrag = `

    vec3 worldPosition = ( modelMatrix * vec4( vPosition, 1.0 )).xyz - center;
    float fragRadius = length(worldPosition);
    float shadowStrength = max(0.0, 1.0 - (strength * (1.0 / (attenuation * (fragRadius - startRadius) + 1.0))));
    gl_FragColor.rgb = gl_FragColor.rgb * shadowStrength;`

    const vPositionDef = "\nvarying vec3 vPosition;\n";
    const vPositionSet = "\nvPosition = position;\n";
    const uMatMatrix = "\nuniform mat4 modelMatrix;\n";

    return function injectFakeAO(shader, renderer, uniforms) {

      // Set default uniforms
      if (typeof uniforms === "undefined") {
        uniforms = {
          color: {value: new THREE.Vector3(1, 1, 1)},
          center: {value: new THREE.Vector3(0, 50, 0)},
          attenuation: {value: 0.8},
          strength: {value: 0.25},
          startRadius: {value: 50.0}
        }
      }

      let declarations = "";
      const uniformPostfix = "";

      for (const key in uniforms) {
        const newKey = key + uniformPostfix;
        if (newKey in shader.uniforms) {
          console.log('WARNING: Key ' + key + ' already in rim light shader uniforms: ', shader.uniforms);
          continue;
        }

        let type = "";
        const assignment = "";
        if (uniforms[key].value.isVector3) {
          type = "vec3";
          // assignment = "vec3(" + uniforms[key].value.x.toFixed(5) + ", " + uniforms[key].value.y.toFixed(5) + ", " + uniforms[key].value.z.toFixed(5) + ");";
        } else if (typeof uniforms[key].value === "number") {
          type = "float";
          // assignment = uniforms[key].value.toFixed(5);
        } else {
          console.log("ERROR: injectFakeAO: Unknown type passed in uniforms as " + key + ":", uniforms[key], uniforms[key].value.isVector3, typeof(uniforms[key].value));
          return;
        }
        declarations += "uniform " + type + " " + newKey + ";";
        shader.uniforms[newKey] = uniforms[key];
      }

      shader.vertexShader = shader.vertexShader.replace(
        "void main() {",
        vPositionDef + "void main() {" + vPositionSet
      );

      // Modify frag shader
      shader.fragmentShader = shader.fragmentShader.replace(
        "void main() {",
        declarations + uMatMatrix + vPositionDef + "void main() {"
      );

      shader.fragmentShader = shader.fragmentShader.replace(
        '#include <dithering_fragment>',
        '#include <dithering_fragment>' + fakeAOFrag
      );

    }
  }();

  injectRimLight = function () {

    const rimLightFrag = `
    {
    vec3 center = vec3(0, 50, 0);
    vec3 worldPosition = ( modelMatrix * vec4( vPosition, 1.0 )).xyz;
    vec3 worldNormal =  normalize( vec3( modelMatrix * vec4(vNormal2, 0.0 ) ) );
    mat4 inverseViewMatrix = inverse(viewMatrix);
    vec3 cameraWorld = (inverseViewMatrix * vec4(rimOffset, 1.0)).xyz;
    vec3 toCenter = center - cameraWorld;
    float dist = (length(toCenter) - 75.0) / 80.0;
    dist = clamp(dist, 0.0, 1.0);
    vec3 viewVector = normalize(cameraWorld - worldPosition);
    float rimndotv =  max(0.0, width - dot(worldNormal, viewVector));
    vec3 rimLight = color;
    vec3 finalLight = rimLight;
    gl_FragColor.rgb = gl_FragColor.rgb + (finalLight * rimndotv * rimndotv * strength * dist);
    }
    `

    const vPositionDef = "\nvarying vec3 vPosition;\nvarying vec3 vNormal2;\n";
    const vPositionSet = "\nvPosition = position;\n";
    const vNormal2Set = "\nvNormal2 = normal;\n"
    // const uMatMatrix = "\nuniform mat4 modelMatrix;\n";

    const fragDeclarations = `
    uniform mat4 modelMatrix;
    uniform mat4 modelViewMatrix;

    varying vec3 vPosition;
    varying vec3 vNormal2;
    `

    return function injectRimLight(shader, renderer, uniforms, uniformPostfix = "") {

      const rimLightFrag = `
      {
      vec3 center = vec3(0, 50, 0);
      vec3 worldPosition = ( modelMatrix * vec4( vPosition, 1.0 )).xyz;
      vec3 worldNormal =  normalize( vec3( modelMatrix * vec4(vNormal2, 0.0 ) ) );
      mat4 inverseViewMatrix = inverse(viewMatrix);
      vec3 cameraWorld = (inverseViewMatrix * vec4(rimOffset` + uniformPostfix + `, 1.0)).xyz;
      vec3 toCenter = center - cameraWorld;
      float dist = (length(toCenter) - 75.0) / 80.0;
      dist = clamp(dist, 0.0, 1.0);
      vec3 viewVector = normalize(cameraWorld - worldPosition);
      float rimndotv =  max(0.0, width` + uniformPostfix + ` - dot(worldNormal, viewVector));
      vec3 rimLight = color` + uniformPostfix + `;
      vec3 finalLight = rimLight;
      gl_FragColor.rgb = gl_FragColor.rgb + (finalLight * rimndotv * rimndotv * strength` + uniformPostfix + ` * dist);
      }
      `
      // uniform vec3 color;
      // uniform vec3 rimOffset;
      // uniform float strength;
      // uniform float width;

      // Bake in uniforms in shader declarations

      let declarations = "\n";

      for (const key in uniforms) {
        const newKey = key + uniformPostfix;
        if (newKey in shader.uniforms) {
          console.log('WARNING: Key ' + key + ' already in rim light shader uniforms: ', shader.uniforms);
          continue;
        }

        let type = "";
        const assignment = "";
        if (uniforms[key].value.isVector3) {
          type = "vec3";
          // assignment = "vec3(" + uniforms[key].value.x.toFixed(5) + ", " + uniforms[key].value.y.toFixed(5) + ", " + uniforms[key].value.z.toFixed(5) + ");";
        } else if (typeof uniforms[key].value === "number") {
          type = "float";
          // assignment = uniforms[key].value.toFixed(5);
        } else {
          console.log("ERROR: injectRimLight: Unknown type passed in uniforms as " + key + ":", uniforms[key], uniforms[key].value.isVector3, typeof(uniforms[key].value));
          return;
        }
        declarations += "uniform " + type + " " + newKey + ";";
        shader.uniforms[newKey] = uniforms[key];
      }

      // Do first-run modifications
      if (!uniformPostfix) {
        shader.vertexShader = shader.vertexShader.replace(
          "void main() {",
          vPositionDef + "void main() {" + vPositionSet + vNormal2Set
        );

        declarations += fragDeclarations;
      }

      shader.fragmentShader = declarations + shader.fragmentShader;

      shader.fragmentShader = shader.fragmentShader.replace(
        '}',
        rimLightFrag + '}'
      );

      // console.log('rim light shader', shader);

    }
  }();

  // Adds a label at the anchor point of mesh
  addLabel (mesh, text) {

    // Find the anchor
    let anchor = null;
    const nChildren = mesh.children.length;
    for (let i = 0; i < nChildren; i++) {
      const name = mesh.children[i].name;
      if (name.substr(name.length - 6, 6).toLowerCase() == "anchor") {
        anchor = mesh.children[i];
        break;
      }
    }

    // Error check
    if( !anchor ) {
      console.log('WARNING: tried to add label to ' + mesh.name + ' but no anchor found.');
      return;
    }

    // Create the label
    const div = document.createElement('div');
    div.className = 'label';
    div.textContent = text;
    const label = new CSS2DObject(div);
    label.userData.labelType = "name"
    // label.visible = false;

    // console.log(label);



    // Add the label as a child of anchor
    anchor.add(label);

    // console.log(mesh);

    // Add a small label offset
    // anchor.position.z -= 0.1;
  }

  addCountries(file) {
    const scope = this;

    // Construct and return a promise wrapping THREE's load procedure
    return new Promise( ( resolve, reject ) => {

      // Initialize the materials we'll need
      const bottomBorderMaterial = new THREE.MeshLambertMaterial ({
        side: THREE.DoubleSide,
        color: "#A0BDDA"
      });

      // Add radial gradient shader snippet to the bottom border material shader
      // bottomBorderMaterial.onBeforeCompile = function (shader, renderer) {
      //   scope.injectFakeAO(shader, renderer);
      // };

      const topBorderMaterial = new THREE.MeshLambertMaterial ();

      // Add radial gradient shader snippet to the top border material shader
      // const uniforms = {
      //   color: {value: new THREE.Vector3(1, 1, 1)},
      //   center: {value: new THREE.Vector3(0, 50, 0)},
      //   attenuation: {value: 0.8},
      //   strength: {value: 0.25},
      //   startRadius: {value: 50.0}
      // }
      // topBorderMaterial.onBeforeCompile = function (shader, renderer) {
      //   scope.injectFakeAO(shader, renderer, uniforms);
      // };

      scope.loader.load (
        file,
        // onLoad
        function ( gltf )  {
    
          // Do per-object processing
          gltf.scene.traverse ( obj => {
    
            // Filter out objects that we don't care about
            if ( !obj.isMesh )
              return;
    
            // We know obj is a mesh, so it gets a new name for clarity
            const mesh = obj;

            /// //////////////////////////////////////////
            // Top-level mesh processing (face meshes)
            /// //////////////////////////////////////////
            if (mesh.parent == gltf.scene) {

              mesh.receiveShadow = true;

              mesh.region = new Region(mesh)
              mesh.children.forEach(
                (obj) => (obj.region = mesh.region)
              )

              // Query state info
              const name = mesh.name.replace(/_/g, " ");

              // Save state info
              mesh.userData.name = name;

              const gray = randGrayNum()
              mesh.material = mesh.material.clone();
              mesh.material.color.set(gray);

              // Save the base color
              mesh.userData.baseColor = mesh.material.color.clone();
              mesh.userData.baseEmissive = mesh.material.emissive.clone();

              // Save the color that the state should be when inactive (unhighlighted)
              mesh.userData.inactiveColor = mesh.material.color.clone();
              mesh.userData.inactiveEmissive = mesh.material.emissive.clone();

              // Save the old scale
              mesh.userData.loweredScale = mesh.scale.clone();

              // Save the new scale
              mesh.userData.randomScale = mesh.scale.clone();
              
              // Randomly raise the countires
              const scale = 1 + Math.random()*0.025;
              mesh.userData.randomScale.multiplyScalar(scale);
              mesh.scale.multiplyScalar(scale);

              // Special case for russia & Canada
              // Prevent the geometry from sinking below the water sphere
              if (name === "Russian Federation") {
                mesh.userData.loweredScale.set(.01026, .01026, .01026);
                mesh.userData.randomScale.set(.01026, .01026, .01026);
                mesh.scale.copy(mesh.userData.randomScale);
              }

              if (name === "Canada") {
                mesh.userData.loweredScale.set(.01020, .01020, .01020);
                mesh.userData.randomScale.set(.01020, .01020, .01020);
                mesh.scale.copy(mesh.userData.randomScale);
              }
              

              // Can be "lowered" or "raised"
              // mesh.userData.state = "raised";
            }

            /// ///////////////////////////////////////////
            // BottomBorder mesh processing
            /// ///////////////////////////////////////////
            if (mesh.name.endsWith("_BottomBorder")) {
              mesh.material = bottomBorderMaterial.clone();
              // Add radial gradient shader snippet to the bottom border material shader
              mesh.material.onBeforeCompile = function (shader, renderer) {
                scope.injectFakeAO(shader, renderer);
              };
              mesh.castShadow = true
              // mesh.receiveShadow = true
            }

            /// ///////////////////////////////////////////
            // TopBorder mesh processing
            /// ///////////////////////////////////////////
            if (mesh.name.endsWith("_TopBorder")) {
              mesh.material = topBorderMaterial.clone();

              // Add radial gradient shader snippet to the top border material shader
              // const uniforms = {
              //   color: {value: new THREE.Vector3(1, 1, 1)},
              //   center: {value: new THREE.Vector3(0, 50, 0)},
              //   attenuation: {value: 0.8},
              //   strength: {value: 0.25},
              //   startRadius: {value: 50.0}
              // }
              // mesh.material.onBeforeCompile = function (shader, renderer) {
              //   scope.injectFakeAO(shader, renderer, uniforms);
              // };
              mesh.castShadow = true;
            }

            /// ///////////////////////////////////////////
            // General mesh processing
            /// ///////////////////////////////////////////

            // Save the base color
            mesh.userData.baseColor = mesh.material.color.clone();
            mesh.userData.baseEmissive = mesh.material.emissive.clone();

            // Save the color that the state should be when inactive (unhighlighted)
            mesh.userData.inactiveColor = mesh.material.color.clone();
            mesh.userData.inactiveEmissive = mesh.material.emissive.clone();
    
            // Set the type of the mesh
            // The type of the mesh (state, county, zip, city) is determined by what file it comes from
            // Since that information isn't automatically attached to the mesh, we need to add it here
            mesh.userData.type = "state";

            mesh.tweens = new TweenGroup();
          });

          // Transform the scene as necessary
          gltf.scene.scale.multiplyScalar(49.5);
          // gltf.scene.rotation.x = -Math.PI * 0.003
          // gltf.scene.rotation.y = Math.PI * 0.006
          // gltf.scene.rotation.z = -Math.PI * 0.007

          // document.querySelector('canvas').setAttribute('globe',true);
          // loadingScreen()

          // Resolve the promise
          resolve(gltf);
        },
        // onProgress - no Promise equivalent
        function ( xhr ) {
          if ((xhr.loaded / xhr.total * 100 ) == 100){
            // document.querySelector('canvas').setAttribute('globe',true);
            // loadingScreen()
          }
        },
        // onError
        function ( error ) {
          reject(error);
        }
      ); // End loader.load()
    }); // End Promise()
  } // End addCountriesV2()

  addStatesV2() {
    const scope = this;

    // Construct and return a promise wrapping THREE's load procedure
    return new Promise( ( resolve, reject ) => {

      // Initialize the materials we'll need
      const bottomBorderMaterial = new THREE.MeshLambertMaterial ({
        side: THREE.DoubleSide,
        color: "#A0BDDA"
      });

      // Add radial gradient shader snippet to the bottom border material shader
      // bottomBorderMaterial.onBeforeCompile = function (shader, renderer) {
      //   scope.injectFakeAO(shader, renderer);
      // };

      const topBorderMaterial = new THREE.MeshLambertMaterial ();

      // Add radial gradient shader snippet to the top border material shader
      // const uniforms = {
      //   color: {value: new THREE.Vector3(1, 1, 1)},
      //   center: {value: new THREE.Vector3(0, 50, 0)},
      //   attenuation: {value: 0.8},
      //   strength: {value: 0.25},
      //   startRadius: {value: 50.0}
      // }
      // topBorderMaterial.onBeforeCompile = function (shader, renderer) {
      //   scope.injectFakeAO(shader, renderer, uniforms);
      // };

      scope.loader.load (
        '/assets/glb/globe/states.glb',
        // onLoad
        function ( gltf )  {

          // console.log( "STATES LOADED: ", gltf )
    
          // Do per-object processing
          gltf.scene.traverse ( obj => {
    
            // Filter out objects that we don't care about
            if ( !obj.isMesh )
              return;
    
            // We know obj is a mesh, so it gets a new name for clarity
            const mesh = obj;

            /// //////////////////////////////////////////
            // Top-level mesh processing (face meshes)
            /// //////////////////////////////////////////
            if (mesh.parent == gltf.scene) {
              // Query state info
              const fips = mesh.name;
              const state_info = STATE_INFO_BY_FIPS[fips];

              // Save state info
              mesh.userData.name = state_info.name;
              mesh.userData.abbr = state_info.abbr;
              mesh.userData.fips = state_info.fips;

              scope.addLabel (mesh, mesh.userData.name);

              // Region is part of the upcoming refactor
              mesh.region = new HighlightableFaceRegion(mesh)
              mesh.children.forEach(
                  (obj) => (obj.region = mesh.region)
              )

              const gray = randGrayNum()
              mesh.material = mesh.material.clone();
              mesh.material.color.set(gray);

              // Save the scale that the states will transition to when clicked
              mesh.userData.clickedScale = new THREE.Vector3(.0109, .0109, .0109);

              // Save the initial scale
              mesh.userData.initialScale = mesh.scale.clone();

              // Save the scale that the states will lower to while they're interactive
              mesh.userData.loweredScale = new THREE.Vector3(.0106, .0106, .0106);

              // All non-mainland states are permanently raised
              if (nonMainlandList.includes(mesh.userData.abbr)) {
                const scale = 1.025 * (49.5 / 48.2);
                mesh.userData.randomScale = mesh.scale.clone().multiplyScalar(scale);
                mesh.scale.multiplyScalar(scale);

                // Save the scale that states will be when lowered
                mesh.userData.hiddenScale = mesh.scale.clone();
              } else {
                // Save the randomized scale that the states will raise to when first presented afte zooming in
                let scale = 1.045 + Math.random() * 0.025;

                // Exception for Washington DC - since it's so small, we want it to always be pretty high
                if (mesh.userData.fips === "11") {
                  scale = 1.045 + 1 * 0.025;
                }

                mesh.userData.randomScale = mesh.scale.clone().multiplyScalar(scale);

                // Save the scale that states will be when lowered
                mesh.userData.hiddenScale = mesh.scale.clone();
              }

              // Can be "lowered" or "raised"
              mesh.userData.state = "raised";

              mesh.tweens = new TweenGroup();
            }

            /// ///////////////////////////////////////////
            // BottomBorder mesh processing
            /// ///////////////////////////////////////////
            if (mesh.name.endsWith("_BottomBorder")) {
              mesh.material = bottomBorderMaterial.clone();
              // Add radial gradient shader snippet to the bottom border material shader
              mesh.material.onBeforeCompile = function (shader, renderer) {
                scope.injectFakeAO(shader, renderer);
              };
              mesh.castShadow = true;
            }

            /// ///////////////////////////////////////////
            // TopBorder mesh processing
            /// ///////////////////////////////////////////
            if (mesh.name.endsWith("_TopBorder")) {
              mesh.material = topBorderMaterial.clone();

              // Add radial gradient shader snippet to the top border material shader
              // const uniforms = {
              //   color: {value: new THREE.Vector3(1, 1, 1)},
              //   center: {value: new THREE.Vector3(0, 50, 0)},
              //   attenuation: {value: 0.8},
              //   strength: {value: 0.25},
              //   startRadius: {value: 50.0}
              // }
              // mesh.material.onBeforeCompile = function (shader, renderer) {
              //   scope.injectFakeAO(shader, renderer, uniforms);
              // };
              mesh.castShadow = true;
            }

            /// ///////////////////////////////////////////
            // General mesh processing
            /// ///////////////////////////////////////////

            // Save the base color
            mesh.userData.baseColor = mesh.material.color.clone();
            mesh.userData.baseEmissive = mesh.material.emissive.clone();

            // Save the color that the state should be when inactive (unhighlighted)
            mesh.userData.inactiveColor = mesh.material.color.clone();
            mesh.userData.inactiveEmissive = mesh.material.emissive.clone();

            // Enable shadows
            mesh.receiveShadow = true;
    
            // Set the type of the mesh
            // The type of the mesh (state, county, zip, city) is determined by what file it comes from
            // Since that information isn't automatically attached to the mesh, we need to add it here
            mesh.userData.type = "state";
          });

          // Transform the scene as necessary
          gltf.scene.scale.multiplyScalar(48.2);
          // gltf.scene.rotation.x = -Math.PI * 0.003
          // gltf.scene.rotation.y = Math.PI * 0.006
          // gltf.scene.rotation.z = -Math.PI * 0.007

          // document.querySelector ('canvas').setAttribute ('usa',true);
          // loadingScreen ()

          // Resolve the promise
          resolve(gltf);
        },
        // onProgress - no Promise equivalent
        function ( xhr ) {
          if ((xhr.loaded / xhr.total * 100 ) == 100){

          }
        },
        // onError
        function ( error ) {
          reject(error);
        }
      ); // End loader.load()
    }); // End Promise()
  } // End addStatesV2()

  addMainland() {
    const scope = this;

    // Construct and return a promise wrapping THREE's load procedure
    return new Promise( ( resolve, reject ) => {

      // Initialize the materials we'll need
      const bottomBorderMaterial = new THREE.MeshLambertMaterial ({
        side: THREE.DoubleSide,
        color: "#A0BDDA"
      });

      // Add radial gradient shader snippet to the bottom border material shader
      // bottomBorderMaterial.onBeforeCompile = function (shader, renderer) {
      //   scope.injectFakeAO(shader, renderer);
      // };

      const topBorderMaterial = new THREE.MeshLambertMaterial ();

      // Add radial gradient shader snippet to the top border material shader
      // const uniforms = {
      //   color: {value: new THREE.Vector3(1, 1, 1)},
      //   center: {value: new THREE.Vector3(0, 50, 0)},
      //   attenuation: {value: 0.8},
      //   strength: {value: 0.25},
      //   startRadius: {value: 50.0}
      // }
      // topBorderMaterial.onBeforeCompile = function (shader, renderer) {
      //   scope.injectFakeAO(shader, renderer, uniforms);
      // };

      scope.loader.load (
        '/assets/glb/globe/mainland.glb',
        // onLoad
        function ( gltf )  {

          // console.log( "STATES LOADED: ", gltf )
    
          // Do per-object processing
          gltf.scene.traverse ( obj => {
    
            // Filter out objects that we don't care about
            if ( !obj.isMesh )
              return;
    
            // We know obj is a mesh, so it gets a new name for clarity
            const mesh = obj;

            /// //////////////////////////////////////////
            // Top-level mesh processing (face meshes)
            /// //////////////////////////////////////////
            if (mesh.parent == gltf.scene) {

              scope.addLabel (mesh, "United States of America");
              mesh.userData.state = "visible";

              // Region is part of the upcoming refactor
              mesh.region = new HighlightableFaceRegion(mesh)
              mesh.children.forEach(
                  (obj) => (obj.region = mesh.region)
              )

              const gray = randGrayNum()
              mesh.material = mesh.material.clone();
              mesh.material.color.set(gray);

              // Save the scale that the states will lower to while they're interactive
              mesh.userData.loweredScale = new THREE.Vector3(.0106, .0106, .0106);

              // Save the scale that the states will transition to when clicked
              mesh.userData.clickedScale = new THREE.Vector3(.0109, .0109, .0109);

              // Save the initial scale
              mesh.userData.initialScale = mesh.scale.clone();

              // Save the scale that states will be when lowered
              mesh.userData.hiddenScale = mesh.scale.clone();

              mesh.userData.randomScale = mesh.scale.clone();

              // Raise the usa mesh
              const scale = 1 + 0.025;
              mesh.userData.randomScale.multiplyScalar(scale);
              mesh.scale.multiplyScalar(scale);

              mesh.tweens = new TweenGroup();
            }

            /// ///////////////////////////////////////////
            // BottomBorder mesh processing
            /// ///////////////////////////////////////////
            if (mesh.name.endsWith("_BottomBorder")) {
              mesh.material = bottomBorderMaterial.clone();
              // Add radial gradient shader snippet to the bottom border material shader
              mesh.material.onBeforeCompile = function (shader, renderer) {
                scope.injectFakeAO(shader, renderer);
              };
              mesh.castShadow = true;
            }

            /// ///////////////////////////////////////////
            // TopBorder mesh processing
            /// ///////////////////////////////////////////
            if (mesh.name.endsWith("_TopBorder")) {
              mesh.material = topBorderMaterial.clone();

              // Add radial gradient shader snippet to the top border material shader
              // const uniforms = {
              //   color: {value: new THREE.Vector3(1, 1, 1)},
              //   center: {value: new THREE.Vector3(0, 50, 0)},
              //   attenuation: {value: 0.8},
              //   strength: {value: 0.25},
              //   startRadius: {value: 50.0}
              // }
              // mesh.material.onBeforeCompile = function (shader, renderer) {
              //   scope.injectFakeAO(shader, renderer, uniforms);
              // };
              mesh.castShadow = true;
            }

            /// ///////////////////////////////////////////
            // General mesh processing
            /// ///////////////////////////////////////////

            // Save the base color
            mesh.userData.baseColor = mesh.material.color.clone();
            mesh.userData.baseEmissive = mesh.material.emissive.clone();

            // Save the color that the state should be when inactive (unhighlighted)
            mesh.userData.inactiveColor = mesh.material.color.clone();
            mesh.userData.inactiveEmissive = mesh.material.emissive.clone();

            // Enable shadows
            mesh.receiveShadow = true;
    
            // Set the type of the mesh
            // The type of the mesh (state, county, zip, city) is determined by what file it comes from
            // Since that information isn't automatically attached to the mesh, we need to add it here
            mesh.userData.type = "state";
          });

          // Transform the scene as necessary
          gltf.scene.scale.multiplyScalar(48.2);
          // gltf.scene.rotation.x = -Math.PI * 0.003
          // gltf.scene.rotation.y = Math.PI * 0.006
          // gltf.scene.rotation.z = -Math.PI * 0.007

          // document.querySelector ('canvas').setAttribute ('usa',true);
          // loadingScreen ()

          // Resolve the promise
          resolve(gltf);
        },
        // onProgress - no Promise equivalent
        function ( xhr ) {
          if ((xhr.loaded / xhr.total * 100 ) == 100){

          }
        },
        // onError
        function ( error ) {
          reject(error);
        }
      ); // End loader.load()
    }); // End Promise()
  } // End addStatesV2()


  addStates(stateGroup,city_list, onLoaded){

    const temp = this

    let nLoaded = 0;
    let stateData;
    let anchorData;
    function onStateOrAnchorsLoaded(data, which) {
      nLoaded++
      console.log('state or anchors loaded: ' + which + nLoaded)
      if (which == 'state') {
        stateData = data;
      } else if (which == 'anchors') {
        anchorData = data;
      }

      if (nLoaded == 2) {
        // console.log("both loaded");
        // Both are loaded here
        const length = anchorData.scene.children.length;
        let anchor_index = 0;
        for (let i = 0; i < length; i++) {
          const anchor = anchorData.scene.children[anchor_index];
          const name = anchor.name.substring(0, anchor.name.length - 7);
          // Find the corresponding county object
          const nStates = stateData.children.length;
          let matchedState = null;
          for (var j = 0; j < nStates; j++) {
            const state = stateData.children[j];

            if (state.name == name) {
              matchedState = state;
              break;
            }
          }

          // Error check
          if (!matchedState) {
            console.log('WARNING: no county match found for ' + anchor.name + ' (searching ' + name + ')');
            anchor_index++;
            continue;
          }

          // Find the face of the state
          let face = null;
          for (var j = 0; j < matchedState.children.length; j++) {
            const mesh = matchedState.children[j];
            if (mesh.material.name.includes("Material")) {
              face = mesh;
              break;
            }
          }

          // Error check
          if (!face) {
            console.log("WARNING: Attaching state anchors: Could not find face of state group", matchedState);
            return;
          }



          const anchorOffsetMagnitude = 0.002;

          // Add a small offset
          const anchorOffset = new THREE.Vector3();
          anchorOffset.copy(anchor.position);

          // This is black magic. I have no idea why this works.
          // Maybe I haven't been getting enough sleep lately.
          matchedState.parent.updateWorldMatrix(true);
          matchedState.parent.localToWorld(anchor.position);
          anchor.position.sub(new THREE.Vector3(0, 50, 0));

          face.attach(anchor);

          let stateReadableName = matchedState.name;

          // Replace underscores with spaces
          stateReadableName = stateReadableName.replace(/_/g, ' ');
          temp.addLabel(face, stateReadableName);

        }
        if (onLoaded)
          onLoaded(stateData);
      }
    }

      // Load label anchors
    this.loader.load( '/assets/glb/state_anchors.glb',
      function ( gltf ) {
        temp.scene.add(gltf.scene)
        onStateOrAnchorsLoaded(gltf, 'anchors');
      },
      // onProgress
      null,
      // onError
      function(error) {
        console.log('error loading anchors:', error)
      }
    );

    this.loader.load( '/assets/glb/USAMorg6_draco3.glb', function ( gltf ) {

      const length = gltf.scene.children.length;
      for (let i = 0; i<length; i++){

        const name = gltf.scene.children[0].name;

        // Skip puerto rico for now? 
        if (name.includes("Puerto_Rico")) {
          gltf.scene.remove(gltf.scene.children[0]);
          continue;
        }

        const j_len = gltf.scene.children[0].children.length;
        for (let j=0; j< j_len; j++){

          const mesh = gltf.scene.children[0].children[j];

          if (!temp.isHawaiiOrAlaska(mesh)) {
            mesh.scale.x = 0.98
            mesh.scale.y = 0.98
            mesh.scale.z = 0.98
          }

          // clone all materials
          // when we remove a state this will allow all other materials that would be otherwise linked to remain
          // helps in highlighting as well
          mesh.material = mesh.material.clone()

          // Enable shadows
          if (mesh.isMesh) {
            mesh.castShadow = true;
            mesh.receiveShadow = true;
            mesh.userData.type = "state";
          }

          // Set state face color
          if (mesh.material.name.includes("Material") ){
            const grey = randGrayNum()
            mesh.material.color.set(grey);
          }

          // Add the fake AO shader to add radial gradient to the borders
          if (mesh.material.name.includes("SOLID")) {
            mesh.material.onBeforeCompile = function (shader, renderer) {
              temp.injectFakeAO(shader, renderer);
            };
          }
        }

        // Below can be found Tim's secret number
        // 627485

        const city = city_list[name]
        // console.log(city);
        const lat = deg2rad(city.center_lat)
        const lon = deg2rad(city.center_long)

        // console.log(lon,lat);

        const R = 50
        const x = R * Math.cos(lat) * Math.cos(lon)
        const y = R * Math.cos(lat) * Math.sin(lon)
        const z = R * Math.sin(lat)

        gltf.scene.children[0].abbr = city.abbr
        gltf.scene.children[0].statePosition =  {x,y:z,z:-y}

        gltf.scene.children[0].stateRotation = {
          x:-lat,
          y:lon+(Math.PI)/2,
          z:-lat/8,// lat/2//-(Math.PI)/2
        }

        stateGroup.add(gltf.scene.children[0])
      }
      stateGroup.scale.x = 50
      stateGroup.scale.y = 50
      stateGroup.scale.z = 50

      stateGroup.rotation.y = -Math.PI/2

      onStateOrAnchorsLoaded(stateGroup, 'state');
      // stateGroup.add(temp.usa)
      // console.log(this.pointer);

      debugger;
      // document.querySelector('canvas').setAttribute('usa',true);
      // loadingScreen()

    }, // called while loading is progressing
  	function ( xhr ) {

      if ((xhr.loaded / xhr.total * 100 ) == 100){

      }

  	}, function ( error ) {
      console.error( error );
    } );

  }

  makeGray(obj) {
    if(!obj.isMesh)
      return;

    if (obj.material.color) {
      if (!obj.material.color.set) {
        console.log("no set on", obj.material.name, obj.parent.name);
        return;
      }

      obj.material.color.set("#121212");
    }
  }

  // addGlobeMap(world){

  //   /** **GLTF Loader old way to import shapers***/
  //   const temp = this
  //   this.loader.load( '/assets/glb/GlobeEric4.glb', function ( gltf ) {


  //     const b = new THREE.Color(1,1,1);
  //     const black = b.getHex()
  //     let object = null; let mesh; let name;
  //     // console.log('dumping globe')
  //     for (let i = 0; i<gltf.scene.children.length; i++){
  //       // console.log(gltf.scene.children[i].name + " is name");
  //       if (!gltf.scene.children[i].isMesh) {
  //         object = gltf.scene.children[i];
  //         mesh = object.children[0];
  //         name = object.name;
  //         mesh.material.color.set("#111");
  //         // console.log(mesh.material);
  //         // mesh.material.emissive.set("#222");
  //       } else {
  //         mesh = gltf.scene.children[i];
  //         object = mesh;
  //         name = object.name;
  //         mesh.material.color.set("#111");
  //         // mesh.material.emissive.set("#222");
  //         // console.log(name);
  //         // console.log(mesh.material);
  //       }

  //       if (mesh.isMesh) {
  //         // Doesn't produce noticeable shadows
  //         mesh.castShadow = true;
  //         mesh.receiveShadow = true;

  //       }


  //       if (mesh.material){


  //         if (mesh.material.name == "Bords.002" || mesh.material.name == "Bords.001") {
  //           mesh.material.onBeforeCompile = function(shader, renderer) {

  //             temp.injectFakeAO(shader, renderer);

  //           }
  //         } else {

  //           // mesh.material.onBeforeCompile = function(shader, renderer) {
  //           //   var uniforms = {
  //           //     color: { value: new THREE.Vector3(0.85, 0.97, 1.0) },
  //           //     // +x is right
  //           //     // +y is up
  //           //     // +z is away (don't use)
  //           //     rimOffset: { value: new THREE.Vector3(-15.0, 30.0, 0.0) },
  //           //     strength: { value: 2.9 },
  //           //     width: { value:   0.35}
  //           //   };

  //           //   temp.injectRimLight(shader, renderer, uniforms);

  //           //   uniforms = {
  //           //     color: { value: new THREE.Vector3(0.85, 0.97, 1.0) },
  //           //     // +x is right
  //           //     // +y is up
  //           //     // +z is away (don't use)
  //           //     rimOffset: { value: new THREE.Vector3(0.0, -60.0, 0.0) },
  //           //     strength: { value: 1.5 },
  //           //     width: { value:   0.35}
  //           //   };

  //           //   temp.injectRimLight(shader, renderer, uniforms, '2');
  //           // }
  //         }
  //       }
  //     }
  //     temp.planet = gltf.scene
  //     temp.planet.name = 'Earth'
  //     // console.log(temp.planet);
  //     temp.planet.scale.x = 50
  //     temp.planet.scale.y = 50
  //     temp.planet.scale.z = 50

  //     temp.planet.rotation.y = -Math.PI/2

  //     world.add(temp.planet)
  //     // console.log(this.pointer);

  //     document.querySelector('canvas').setAttribute('globe',true);
  //     loadingScreen()

  //   }, // called while loading is progressing
  //   function ( xhr ) {

  //     // console.log( ( xhr.loaded / xhr.total * 100 ) + '% loaded' );
  //     if ((xhr.loaded / xhr.total * 100 ) == 100){

  //     }

  //   }, function ( error ) {
  //     console.error( error );
  //   } );

  // }
  // TODO: Promisify this?
  addLights(scene, controls, performanceManager, {shadowMapSize}){

    /** **GLTF Loader old way to import shapers***/
    const temp = this
    // const gray = new THREE.MeshBasicMaterial( { color: "#3c3c3c" } );
    this.loader.load( '/assets/glb/LightsOnlySun.glb', function ( gltf ) {

      // The actual DirectionalLight is nested 8 objects deep here
      let sun = gltf.scene.children[0];
      while(sun.type != 'DirectionalLight') {
        sun = sun.children[0];
      }

      performanceManager.setSun(sun);
      controls.setLight(gltf.scene, sun);

      // TODO: Tie this with zoom level so shadows stay crisp at smaller scales
      sun.castShadow = true;
      sun.shadow.camera.near = 230;
      sun.shadow.camera.far = 300;
      sun.shadow.camera.left = -50;
      sun.shadow.camera.bottom = -50;
      sun.shadow.camera.right = 50;
      sun.shadow.camera.top = 50;

      sun.intensity = 0.8;

      sun.shadow.bias = -0.0003;
      // sun.shadow.radius = 4;
      // sun.shadow.blurSamples = 128;
      sun.shadow.mapSize.copy(shadowMapSize)

      sun.target.position.copy(new THREE.Vector3(0, 50, 0));

      scene.add(sun.target);

      // var helper = new THREE.CameraHelper( sun.shadow.camera );
      // scene.add(helper);
      // sun.userData.helper = helper;

      const b = new THREE.Color(1,1,1);
      const black = b.getHex()

      // console.log(gltf.scene);
      temp.planet = gltf.scene
      temp.planet.name = 'Earth'
      // console.log(temp.planet);
      temp.planet.scale.x = 100
      temp.planet.scale.y = 100
      temp.planet.scale.z = 100
      sun.position.copy(new THREE.Vector3(3, -5.5, -1));

      // temp.planet.rotation.x = Math.PI/2
      // temp.planet.rotation.y = -Math.PI/16
      // temp.planet.rotation.z = Math.PI/2
      scene.add(temp.planet)
      // console.log(this.pointer);

    }, undefined, function ( error ) {
      console.error( error );
    } );

  }
}
function randGrayNum(){
  // Math.seed
  const value = Math.random() * 0x32 + (0x32);
  // var value = Math.random() * 0x10 | 0x43;
  const grayscale = (value << 16) | (value << 8) | value;
  let color = '#' + grayscale.toString(16);
  if (color.length ==6){
    color = color + "0"
  }
  // console.log(color);
  return color // new THREE.MeshLambertMaterial( { color: color } );
}
function randGrayScale(){
  // Math.seed
  const value = Math.random() * 0x66 + (0xAA - 0x66);
  // var value = Math.random() * 0x10 | 0x43;
  const grayscale = (value << 16) | (value << 8) | value;
  let color = '#' + grayscale.toString(16);
  if (color.length ==6){
    color = color + "0"
  }

  return color // new THREE.MeshLambertMaterial( { color: color } );
}
function deg2rad(degrees)
{
  const pi = Math.PI;
  return degrees * (pi/180);
}